/**
 * The machine the machine tour and the "open a machine" tasks show: the one
 * on screen, else the one opened last, else the first machine with data.
 */

import { useSAPDataStore } from "../store/SAPDataStore";

const LAST_MACHINE_KEY = "performanceCockpit-help-machine";

/** MachineView: remember the machine the user opened. */
export function rememberMachine(id: string): void {
  try {
    sessionStorage.setItem(LAST_MACHINE_KEY, id);
  } catch {
    // private mode: the tour falls back to the first machine with data
  }
}

/** A machine id to show, or null when the cockpit knows no machine. */
export function machineForTour(pathname: string): string | null {
  const current = /^\/machine\/([^/?#]+)/.exec(pathname);
  if (current) return current[1];
  try {
    const last = sessionStorage.getItem(LAST_MACHINE_KEY);
    if (last) return last;
  } catch {
    // no storage
  }
  const machines = useSAPDataStore.getState().machines ?? [];
  const machine = machines.find((m) => m.datenVerfuegbar) ?? machines[0];
  if (!machine) return null;
  return machine.maschinennummer || machine.maschineBK || machine.machineId || null;
}
